var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-input",style:({ marginTop: _vm.marginTop, marginLeft: _vm.marginLeft, marginRight: _vm.marginRight, width: _vm.width })})}
var staticRenderFns = []

export { render, staticRenderFns }